const mailchimpScript = document.createElement('script');
mailchimpScript.src = '//js.stripe.com/v3/';
mailchimpScript.id = 'stripe';

mailchimpScript.paypalExpress = "false";

export default mailchimpScript;
